import { lazy, Suspense } from 'react'

import type { ItemId } from '../../itemSlice'

import { ItemBoundary } from '../ItemBoundary/ItemBoundary'
import { ItemTableRowSkeleton } from './ItemTableRowSkeleton'

const ItemTableRow = lazy(() => import('./ItemTableRow'))

export function ItemTable({ ids }: { ids?: ItemId[] }) {
  if (!ids) {
    return null
  }

  return (
    <div className="twc-max-h-[50vh] twc-overflow-y-auto twc-rounded twc-border twc-border-slate-200 dark:twc-border-slate-800">
      <table className="twc-table-fixed twc-border-collapse twc-w-full">
        <thead className="twc-sticky twc-top-0 twc-bg-slate-200 dark:twc-bg-slate-800 twc-drop-shadow">
          <tr>
            <th className="twc-py-1 twc-px-2 xs:twc-py-2 xs:twc-px-3 sm:twc-px-6 twc-text-xs xs:twc-text-sm twc-font-semibold twc-text-left twc-w-1/2 twc-max-w-lg">
              Prop
            </th>
            <th className="twc-py-1 twc-px-2 xs:twc-py-2 xs:twc-px-3 sm:twc-px-6 twc-text-xs xs:twc-text-sm twc-font-semibold twc-text-center twc-max-w-xs">
              Quantity
            </th>
            <th className="twc-py-1 twc-px-2 xs:twc-py-2 xs:twc-px-3 sm:twc-px-6 twc-text-xs xs:twc-text-sm twc-font-semibold twc-text-right">
              Rate
            </th>
          </tr>
        </thead>

        <tbody className="twc-divide-y twc-bg-white/80 dark:twc-divide-slate-800 dark:twc-bg-[#090e19] twc-shadow-inner">
          {ids.map((id) => (
            <tr key={id}>
              <ItemBoundary id={id}>
                <Suspense fallback={<ItemTableRowSkeleton />}>
                  <ItemTableRow id={id} />
                </Suspense>
              </ItemBoundary>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
